import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ListFetchError from "../components/ListFetchError";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchTerms } from "../store/terms/termsSlice";

const SUBTITLE =
  "Contrary to popular belief, Lorem Ipsum is not simply random text";

function TermsAndConditions({ onOpenAuth, onOpenMenu }) {
  const dispatch = useAppDispatch();
  const termsState = useAppSelector((s) => s.terms);

  const loading = termsState?.status === "loading";
  const error = termsState?.error;
  const data = termsState?.data;

  useEffect(() => {
    if (termsState?.status === "idle") dispatch(fetchTerms());
  }, [termsState?.status, dispatch]);

  const retryFetch = () => {
    if (loading) return;
    dispatch(fetchTerms());
  };

  return (
    <div className="min-h-screen bg-[#F5F7FB] text-[#24303A] flex flex-col">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto w-full max-w-full flex-1 px-4 py-10 md:px-6">
        <div className="rounded-3xl border border-[#E6EAF0] bg-white px-6 py-8 shadow-sm md:px-10 md:py-10">
          {loading && !error && (
            <div className="flex justify-center py-12">
              <span className="text-[16px] text-slate-500">Loading…</span>
            </div>
          )}

          {error && (
            <ListFetchError message={error} onRetry={retryFetch} isLoading={loading} />
          )}

          {!loading && !error && data && (
            <>
              <h1 className="text-[24px] font-bold text-[#24303A] md:text-[28px]">
                {data.title || "Terms & Conditions"}
              </h1>
              {/* <p className="mt-2 text-[18px] font-semibold text-[#6E7B86]">{SUBTITLE}</p> */}
              <div
                className="terms-content mt-8 space-y-4 text-left text-[16px] font-normal text-[#6E7B86]"
                dangerouslySetInnerHTML={{
                  __html: data.content || "",
                }}
              />
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default TermsAndConditions;
